import { FC } from 'react'

import { Orb } from '../types'
import { WhiteOrbKingImage } from './white-orb-king-image'

export const WhiteOrbKing: FC<Orb> = ({ onClick, size, className }) => {
  const props = size ? { width: size, height: size } : {}

  return (
    <svg
      x="35"
      y="30"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
      {...props}
    >
      <g filter="url(#filter0_dd_54_898)">
        <rect x="3.65039" y="1" width="47" height="48" fill="url(#white-orb-king)" shapeRendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_dd_54_898"
          x="0.650391"
          y="0"
          width="53"
          height="54"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_898" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_54_898" result="effect2_dropShadow_54_898" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_898" result="shape" />
        </filter>
        <pattern id="white-orb-king" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use href="#WhiteOrbKingImage" transform="matrix(0.00170213 0 0 0.00166667 -0.0106383 0)" />
        </pattern>
        <WhiteOrbKingImage />
      </defs>
    </svg>
  )
}
